import { useContext } from 'react';
import { ContexteAppel } from './contexte';
import type { ContexteAppelValeur } from './types';

export function useAppel(): ContexteAppelValeur {
  const contexte = useContext(ContexteAppel);
  if (!contexte) {
    throw new Error('useAppel doit être utilisé dans un FournisseurAppel');
  }
  return contexte;
}
